<!--
  - Copyright (c) 2022. Haodong JU
  -->

<template>
  <div>
    <template v-if="realData">
      <i-k-p-r-node
        :node="parseNode(realData)"
        level=""
        style="font-family: monospace"
      />
    </template>
    <template v-else>
      <div>
        {{ $t('cantPreviewDataNow') }}
      </div>
    </template>
  </div>
</template>

<script>
  import { previewBonTemplate } from '@/common/Utlis/bonTemplate'
  import IKPRNode from '@/composable/IKPRNode'
  import { parse } from 'node-html-parser'

  export default {
    name: 'TemplateRender',
    components: { IKPRNode },
    props: {
      content: {},
      bonClass: {},
    },
    data: function () {
      return {
        realData: '',
      }
    },
    watch: {
      content: {
        immediate: true,
        async handler () {
          await this.reloadTemplate()
        },
      },
    },
    methods: {
      parseNode (node) {
        return parse(node)
      },
      async reloadTemplate () {
        try {
          this.realData = await previewBonTemplate(this.bonClass, this.content)
        } catch (e) {
          this.realData = ''
        }
      },
    },
  }
</script>

<style scoped>

</style>
